<template>

  <page>

    <object-tag
      slot="page-title"
      type="Inquiry"
      :identifier="guessInquiryIdFromRoute()"
    />

    <div slot="page-buttons">
    </div>

    <div class="columns">
      <div class="column">
        <inquiry-card :attributes="inquiry.attributes">
          <div slot="buttons">
            <btn @click="handleDeleteInquiry" :flat="true" tooltip="Delete inquiry">
              <icon :classes="['fa', 'fa-trash']"/>
            </btn>
          </div>
        </inquiry-card>
      </div>
    </div>

  </page>
</template>

<script>
  import {mapState, mapGetters, mapActions} from 'vuex';
  import P from '~/lib/promise';
  import ObjectTag from '~/components/page/ObjectTag.vue';
  import InquiryContext from './mixins/InquiryContext.vue';
  import PageLifetime from './mixins/PageLifetime.vue';
  import InquiryCard from '~/components/inquiry/InquiryCard.vue';
  import Page from '~/components/Page.vue';
  import Icon from '~/components/Icon.vue';
  import Btn from '~/components/Btn.vue';

  export default {
    mixins: [InquiryContext, PageLifetime],

    components: {
      Btn,
      Icon,
      InquiryCard,
      ObjectTag,
      Page,
    },

    mounted () {
      // Clear before the first paint; see resetCustomerContext. Vue ignores
      // a promise returned from a lifecycle hook, so marking this async
      // never deferred the paint anyway.
      this.resetInquiryContext();
      this.withPageLifetime(async (step) => {
        await step(this.initializeInquiryContext());
      });
    },
  };
</script>
